export default class DecodingContent {
  constructor(rawData) {
    this.content = rawData;
  }

  getTitle() {
    return this.content.title_fakenews_decryptage;
  }
}
